import { usePreventScroll } from '@react-aria/overlays';
import { MainWrapper, StackItemWrapper } from './atoms';
import { useStackPageManager } from './useStackPageManager';
import { FocusScope } from '@react-aria/focus';
import { last, noop } from 'lodash';
import { useEffectOnce } from '@ardoq/hooks';
import { GenericSelectMenuPortalRootContextProvider } from './GenericSelectMenuPortalRootContext';

// This code snippet is to handle the modals that try to load before StackPageManager is mounted
type ResolveFn = (x?: undefined) => void;
let externalResolve: ResolveFn = noop;
const mountedPromise = new Promise((resolve: ResolveFn) => {
  externalResolve = resolve;
});

export const getIsMounted = () => mountedPromise;

export const StackPageManager = () => {
  const { stack, popStackPageById } = useStackPageManager();
  usePreventScroll({ isDisabled: !stack.length });
  const lastStackId = last(stack)?.id;
  const isStackActive = Boolean(stack.length);
  const getIsPageActive = (pageId: string) => lastStackId === pageId;
  useEffectOnce(externalResolve);

  return (
    <MainWrapper $isStackActive={isStackActive}>
      {stack.map(({ StackPage, id, ...restStackPageOptions }, index) => (
        <FocusScope
          key={id}
          contain={getIsPageActive(id)}
          restoreFocus
          autoFocus
        >
          <GenericSelectMenuPortalRootContextProvider
            active={getIsPageActive(id)}
          >
            <StackItemWrapper>
              <StackPage
                stackPageIndex={index}
                stackPageId={id}
                closeStackPage={() => popStackPageById(id)}
                stackPageIsInFocus={getIsPageActive(id)}
                {...restStackPageOptions}
              />
            </StackItemWrapper>
          </GenericSelectMenuPortalRootContextProvider>
        </FocusScope>
      ))}
    </MainWrapper>
  );
};
